import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "Are you licensed to do pest control in Pittsburgh, PA?",
    a: "Yes. Blue Collar World Pest Control operates under Pennsylvania Pesticide Business License #BU15680 and employs state-certified applicators. We're fully insured for households, parks, and schools throughout Allegheny County.",
  },
  {
    q: "Do you offer Spanish-speaking service?",
    a: "Sí. Se habla español. Our team includes bilingual technicians and support staff so Pittsburgh's Spanish-speaking families get clear communication and honest answers.",
  },
  {
    q: "How much does pest control cost in Pittsburgh?",
    a: "Two plans: Quarterly service (standard rate, 4 visits/yr with free re-treatments between visits) and One-Time premium treatment for active infestations. Call 484-764-3392 for a property-specific quote.",
  },
  {
    q: "What pests do you treat?",
    a: "Termites and wood-destroying insects, wildlife (raccoons, groundhogs, bats, squirrels), bed bugs, mosquitoes, plus general household pests — roaches, ants, rodents, spiders.",
  },
  {
    q: "Are your treatments safe for kids and pets?",
    a: "Yes. EPA-compliant methods and family & pet safe options. Our school/playground programs follow strict child-safe protocols with full documentation.",
  },
  {
    q: "How fast can you come out?",
    a: "Same-week scheduling for one-time treatments. We also operate a 24/7 emergency line at 484-764-3392 for urgent issues.",
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="border-b border-zinc-900 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D9480F] font-bold mb-4">
            [ 06 ] — Straight Answers
          </p>
          <h2 className="font-display uppercase font-semibold leading-[0.9] tracking-tighter text-4xl md:text-6xl mb-6">
            Common <br />
            <span className="text-[#0B2B40]">questions.</span>
          </h2>
          <p className="text-zinc-700 leading-relaxed">
            No fine print. No runaround. Here's what Pittsburgh homeowners
            most often ask before booking.
          </p>
        </div>

        <div className="lg:col-span-8">
          <div className="border-t-2 border-black">
            {faqs.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className="border-b-2 border-black">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`faq-toggle-${i}`}
                    className="w-full flex items-start justify-between gap-6 py-6 text-left group"
                  >
                    <span className="font-display uppercase text-lg md:text-xl tracking-tight leading-tight group-hover:text-[#D9480F] transition-colors">
                      {item.q}
                    </span>
                    <ChevronDown
                      className={`w-6 h-6 flex-shrink-0 transition-transform ${
                        isOpen ? "rotate-180 text-[#D9480F]" : ""
                      }`}
                      strokeWidth={2.5}
                    />
                  </button>
                  {isOpen && (
                    <div className="pb-6 pr-10 text-zinc-700 leading-relaxed border-l-2 border-[#D9480F] pl-4 -mt-1">
                      {item.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
